import { render, staticRenderFns } from "./LogoBar.vue?vue&type=template&id=0b215f31&"
import script from "./LogoBar.vue?vue&type=script&lang=js&"
export * from "./LogoBar.vue?vue&type=script&lang=js&"
import style0 from "./LogoBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports